import { getShouldUseZendeskSandbox } from "../serialized-data/getShouldUseZendeskSandbox";
export var RETAILERS_CATEGORY_ID = getShouldUseZendeskSandbox() ? 14636978659099 : 360000269151;